import { render, staticRenderFns } from "./SlotListActions.vue?vue&type=template&id=2b75cc8e"
import script from "./SlotListActions.vue?vue&type=script&lang=js"
export * from "./SlotListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports